import { Component, h, Host, Listen } from '@stencil/core';
import store from '../store';

@Component({
  tag: 'ui-download-search-facets',
  styleUrl: 'ui-download-search-facets.scss',
  shadow: false,
})
export class UiDownloadSearchFacets {
  offcanvasId = 'downloadsearch-facets';

  resetFilterLabel = 'Alle Filter zurücksetzen';

  @Listen('uiCmsOffcanvasProviderUpdate', { target: 'window' })
  onOffcanvasStatusUpdate(
    event: CustomEvent<{ id: string; open: boolean; trigger: CustomEvent }>
  ) {
    if (!(event.detail.id === this.offcanvasId)) {
      return;
    }
    store.state.tracking.filtersOffcanvasOpen = event.detail.open;
    const getTriggerName = () => {
      const trigger = event.detail.trigger.target as HTMLElement;
      if (trigger.id === this.offcanvasId) {
        return 'Filter schließen'; // Offcanvas contains lots of elements, so we manually set the name
      }
      if (
        !trigger.innerText ||
        trigger.innerText.includes('Downloads anzeigen')
      ) {
        return 'Downloads anzeigen'; // Button shows results as integer or nothing during loading, so we reduce to always 'Downloads anzeigen'
      }
      return trigger.innerText;
    };
    store.state.tracking.trackAction(
      'DownloadSearchOffcanvasChange',
      getTriggerName()
    );
    if (
      !store.state.tracking.filtersOffcanvasOpen &&
      store.state.tracking.fetchResultsDelayed
    ) {
      store.state.tracking.trackFetch('DownloadSearchFetchResults');
    }
  }

  private resetFilter = () => {
    store.state.selectedFilters = [];
    store.state.currentQuickfilter = null;
    store.state.tracking.trackAction(
      'DownloadSearchFilterReset',
      this.resetFilterLabel
    );
  };

  private returnApplyAndResetButton() {
    return (
      <div>
        <ui-offcanvas-trigger offcanvas-id={this.offcanvasId}>
          <sd-button
            class="search-facets-panel__button"
            variant="primary"
            size="lg"
            {...(store.state.isFetchingResults ? { loading: 'true' } : {})}
          >
            {store.state.totalResults} Downloads anzeigen
          </sd-button>
        </ui-offcanvas-trigger>
        <ui-button
          class="search-facets-panel__button--reset"
          icon="close-circle"
          onClick={this.resetFilter}
          disabled={store.state.selectedFilters.length < 1}
        >
          {this.resetFilterLabel}
        </ui-button>
      </div>
    );
  }

  render() {
    return (
      <Host>
        <div
          class={{
            mobile: store.state.isMobile,
            'search-facets-wrapper': true,
          }}
        >
          {!store.state.fundsMode && (
            <ui-offcanvas-trigger offcanvas-id={this.offcanvasId}>
              <ui-button
                class="search-facets__button"
                variant={'primary'}
                icon={
                  store.state.selectedFilters.length > 0
                    ? 'filter-filled'
                    : 'filter-empty'
                }
              >
                {store.state.selectedFilters.length > 0
                  ? 'Filter verändern'
                  : 'Ergebnisse filtern'}
              </ui-button>
            </ui-offcanvas-trigger>
          )}
          {store.state.isMobile && (
            <ui-download-search-sort></ui-download-search-sort>
          )}
          {store.state.isMobile && !store.state.fundsMode && (
            <ui-search-sort class="search-facets__button-sort"></ui-search-sort>
          )}
          <span class="search-facets__results-number">
            {store.state.totalResults > store.state.results.length
              ? `${store.state.offset + 1}–${store.state.results.length + store.state.offset}`
              : store.state.results.length}{' '}
            {` von ${store.state.totalResults} ${store.state.fundsMode ? 'Fonds' : 'Downloads'}`}
          </span>
          {!store.state.fundsMode && (
            <ui-button
              class="search-facets__results-reset"
              disabled={store.state.selectedFilters.length === 0}
              icon={'close'}
              variant={'plain'}
              onClick={this.resetFilter}
            >
              {this.resetFilterLabel}
            </ui-button>
          )}
          <ui-offcanvas-panel id={this.offcanvasId} darken close-outside>
            <ui-container variant={'secondary100'}>
              <ui-offcanvas-trigger offcanvas-id={this.offcanvasId}>
                <ui-button
                  class="search-facets-panel__link"
                  variant="plain"
                  icon="close"
                >
                  Filter schließen
                </ui-button>
              </ui-offcanvas-trigger>
              {this.returnApplyAndResetButton()}
              {store.state.facets.map((facet, index) => (
                <ui-download-search-facet
                  facet={facet}
                  key={index}
                ></ui-download-search-facet>
              ))}
              {this.returnApplyAndResetButton()}
            </ui-container>
          </ui-offcanvas-panel>
        </div>
        {!store.state.isMobile && (
          <ui-download-search-sort></ui-download-search-sort>
        )}
      </Host>
    );
  }
}
